import { render, staticRenderFns } from "./EmbeddedBox.vue?vue&type=template&id=fa5bebd2&scoped=true&"
import script from "./EmbeddedBox.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedBox.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedBox.vue?vue&type=style&index=0&id=fa5bebd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5bebd2",
  null
  
)

export default component.exports